import * as React from "react"
import type { SVGProps } from "react"
const SvgReviewSourceStoredotapp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 100 100"
    {...props}
  >
    <path
      fill="currentColor"
      d="M46.232 66.384c0 7.52-6.096 13.616-13.616 13.616S19 73.904 19 66.384s6.096-13.616 13.616-13.616 13.616 6.096 13.616 13.616M46.232 32.616c0 7.52-6.096 13.616-13.616 13.616S19 40.136 19 32.616 25.096 19 32.616 19s13.616 6.096 13.616 13.616M80 66.384C80 73.904 73.904 80 66.384 80s-13.616-6.096-13.616-13.616 6.096-13.616 13.616-13.616S80 58.864 80 66.384M71.286 19h-9.804v8.714h-8.714v9.804h8.714v8.714h9.804v-8.714H80v-9.804h-8.714z"
    />
  </svg>
)
export default SvgReviewSourceStoredotapp
